<template>
  <div class="content-wrapper">
    <page-header :title="title"></page-header>
    <div class="d-flex justify-content-center align-items-center" style="height: 100vh" v-if="isLoadingData">
      <loading></loading>
    </div>
    <div class="card editor-bg mt-1" v-if="Object.keys(rawData).length && !isLoadingData">
      <div class="card-body">
        <div class="row">
          <div :class="matchKeywordInfo ? 'col-sm-6' : 'col-sm-8'">
            <div class="text-info-area" v-html="highlightHTML"></div>
            <div class="d-flex justify-content-end mt-2">
              <button class="btn btn-info" @click="checkKeyword">
                <i class="fas fa-spinner spinner mr-1" v-if="isCheckKeyword"></i>Check Matching
              </button>
            </div>
          </div>

          <div class="col-sm-3" v-if="matchKeywordInfo">
            <div class="card p-2">
              <div>
                <b class="text-success" v-if="matchKeywordInfo.isMatch">Matched</b><b v-else class="text-danger">Not
                  Matched</b>
              </div>
              <div>
                This message
                <span class="text-success" v-if="matchKeywordInfo.isMatch">matches</span>
                <span class="text-danger" v-else>does not match</span> with
                keywords from <b>kbank</b>
              </div>
              <div v-if="matchKeywordInfo.matchedKeyword.length">
                <span>Matched keyword is &nbsp;</span>
                <span class="text-success">{{
                  matchKeywordInfo.matchedKeyword
                    ? matchKeywordInfo.matchedKeyword.join(', ')
                    : '-'
                }}</span>
              </div>

              <div v-if="matchKeywordInfo.matchedExcludedKeyword.length">
                <span>Matched exclude keyword is &nbsp;</span>
                <span class="text-danger">{{
                  matchKeywordInfo.matchedExcludedKeyword
                    ? matchKeywordInfo.matchedExcludedKeyword.join(', ')
                    : '-'
                }}</span>
              </div>

              <!-- <div class="mt-2" v-if="matchKeywordInfo.levels.length">
              <b>Matched Category:</b>
              <div class="row">
              <div v-for="(level,index) in matchKeywordInfo.levels" :key="index" class="col-2">
                <div>Level {{index}} [ {{level.label}} ]</div>
                <table border="1">
                  <thead>
                    <th>Category</th>
                    <th>Matched Keyword</th>
                  </thead>
                  <tbody>
                    <tr v-for="(category,index) in level.categories" :key="`cateogry_${index}`">
                      <td>{{category.category}}</td>
                      <td>{{category.matchingWords.join(", ")}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              </div>
            </div> -->
            </div>
          </div>
          <!-- <div class="col-sm-8">
          <textarea rows="4" v-model="text" class="w-100" style="font-size: 14px;"></textarea>
        </div> -->

          <div class="col-sm-3">
            <!-- <div class="d-flex flex-row justify-content-end mt-3 mb-3">
              <div class="row p-2 bd-highlight">
                <input id="search_field" class="form-control" type="search" placeholder="Search Text" v-model="searchString" ref="search">
              </div>
              <div class="row ml-2">
                <button v-if="isNone || isProgress || isReject" type="button" class="btn btn-primary m-2" @click=readData>Read</button>
                <button v-if="isNone || isProgress || isReject" type="button"
                        class="btn btn-primary m-2"
                        @click=updateStatus(statusReview)>
                        Submit review
                </button>
                <button v-if="isAdmin && (isReview || isDone)" type="button" class="btn btn-primary m-2" @click=updateStatus(statusDone) :disabled="isDone">Approve</button>
                <button v-if="isAdmin && (isReview|| isDone)" type="button" class="btn btn-primary m-2" @click=updateStatus(statusReject) :disabled="isReject">Reject</button>
              </div>
            </div> -->

            <div class="media flex-column">
              <div class="row pl-2 bd-highlight">
                <input id="search_field" class="form-control" type="search" placeholder="Search Text"
                  v-model="searchString" ref="search" />
              </div>
              <div class="row p-0">
                <button v-if="isNone || isProgress || isReject" type="button" class="btn btn-primary m-2"
                  @click="readData">
                  Read
                </button>
                <button v-if="isNone || isProgress || isReject || !countRow" type="button" class="btn btn-primary m-2"
                  @click="updateStatus(statusReview)">
                  Submit review
                </button>
                <button v-if="isAdmin && (isReview || isDone)" type="button" class="btn btn-primary m-2"
                  @click="updateStatus(statusDone)" :disabled="isDone">
                  Approve
                </button>
                <button v-if="isAdmin && (isReview || isDone)" type="button" class="btn btn-primary m-2"
                  @click="updateStatus(statusReject)" :disabled="isReject">
                  Reject
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row mt-2" id="keyword-checker">
        <div class="col-12" v-if="matchKeywordInfo">
          <div class="card mt-2">
            <div class="card-body">
          <div class="mt-3"><b class="text-success" v-if="matchKeywordInfo.isMatch">Matched</b><b v-else class="text-danger">Not Matched</b></div>
          <div>This message <span class="text-success" v-if="matchKeywordInfo.isMatch">matches</span> <span class="text-danger" v-else>does not match</span> with keywords from <b>kbank</b></div>
          <div v-if="matchKeywordInfo.matchedKeyword.length">
            <span>Matched keyword is &nbsp;</span>
            <span class="text-success">{{matchKeywordInfo.matchedKeyword ? matchKeywordInfo.matchedKeyword.join(", "):"-"}}</span>
          </div>

          <div v-if="matchKeywordInfo.matchedExcludedKeyword.length">
            <span>Matched exclude keyword is &nbsp;</span>
            <span class="text-danger">{{matchKeywordInfo.matchedExcludedKeyword ? matchKeywordInfo.matchedExcludedKeyword.join(", "):"-"}}</span>
          </div>

          <div class="mt-2" v-if="matchKeywordInfo.levels.length">
            <b>Matched Category:</b>
            <div class="row">
            <div v-for="(level,index) in matchKeywordInfo.levels" :key="index" class="col-2">
              <div>Level {{index}} [ {{level.label}} ]</div>
              <table border="1">
                <thead>
                  <th>Category</th>
                  <th>Matched Keyword</th>
                </thead>
                <tbody>
                  <tr v-for="(category,index) in level.categories" :key="`cateogry_${index}`">
                    <td>{{category.category}}</td>
                    <td>{{category.matchingWords.join(", ")}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            </div>
          </div>
          </div>
          </div>
          </div>
      </div> -->
        <div class="media flex-column flex-sm-row justify-content-end" style="margin-top: 0px">
          <span class="text-muted"> Rows: {{ countRow }} </span>
        </div>
        <div ref="table"></div>
        <!-- <hot-table :settings="hotSettings" ref="hotTableComponent" style="font-size: 16px;"/> -->
      </div>
    </div>

    <b-modal ok-title="Duplicate" cancel-title="Cancel" centered id="show-duplicate-modal" ref="show_duplicate_modal"
      size="sm" title="Duplicate multiple records" hide-backdrop no-close-on-backdrop @ok="duplicateMultiple">
      <input type="number" v-model="duplicateRecordInput" class="form-control" placeholder="Enter number of records"
        min="1" />
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loading from '../components/Loading'
import Handsontable from 'handsontable'

import PageHeader from '../views/layout/PageHeader'
import moment from 'moment'
import serviceRoutes from '../service-routes'
import { BModal, VBModal } from 'bootstrap-vue'
import _ from 'lodash'
export default {
  components: {
    Loading,
    PageHeader,
    BModal
  },
  directives: { VBModal },
  created() {
    this.getUndeletedPages()
  },
  data() {
    return {
      columnKeyValues: {},
      selectedRow: null,
      duplicateRecordInput: 0,
      isCheckKeyword: false,
      invalidCell: [],
      isLoadingData: true,
      matchKeywordInfo: null,
      hotSettings: {
        undo: false,
        manualColumnResize: true,
        manualRowResize: true,
        colWidths: null,
        height: '450',
        className: 'htLeft',
        data: Handsontable.helper.createSpreadsheetData(4, 4),
        rowHeaders: true,
        colHeaders: null,
        columns: null,
        columnSorting: true,
        multiColumnSorting: true,
        filters: true,
        // dropdownMenu: ['filter_by_condition', 'filter_action_bar', 'filter_by_value'],
        dropdownMenu: {
          items: {
            clear_filters: {
              // name: 'Clear filter',
              name: '<div class="text-right"><font color="#3c82cc">Clear filter</font></div>',
              callback: this.removeConditions
            },
            hsep3: '---------',
            filter_by_condition: {},
            filter_by_value: {},
            filter_action_bar: {}
          }
        },
        search: true,
        contextMenu: {
          items: {
            duplicate_row: {
              name: 'Duplicate row',
              callback: this.duplicate
            },
            duplicate_multiple_row: {
              name: 'Duplicate multiple row',
              callback: this.showDuplicateMultipleForm
            },
            remove_row: {
              name: 'Delete row',
              callback: this.deleteRow
            }
            // 'clear_filters': {
            //   name: 'Clear filter',
            //   callback: this.removeConditions
            // }
          }
        },
        afterChange: (changes) => {
          if (changes) {
            for (const change of changes) {
              let [row, column, oldValue, newValue] = change
              // [row,column,oldValue,newValue]
              this.changeData(row, column, oldValue, newValue)
            }
          }
          this.highlightAndValidate(false)
        },
        afterSelection: (row, column) => {
          this.text = this.hot.getDataAtCell(row, column)
          this.countRow = this.hot.getData() ? this.hot.getData().length : 0
          this.highlightAndValidate(false)
        },
        afterFilter: async () => {
          console.time('highlight + validate')
          await this.highlightAndValidate()
          console.timeEnd('highlight + validate')
          this.changeFilter()
          // store editor filter
        },
        afterValidate: (isValid, value, row, prop, source) => {
          if (!isValid) {
            this.invalidCell.push(row)
          }
        }
      },
      searchString: '',
      text: '',
      isDuplicating: false,
      isInProgress: false,
      statusNone: 'None',
      statusReview: 'To review',
      statusInReview: 'In review',
      statusDone: 'Done',
      statusReject: 'Reject',
      statusRead: 'Read',
      statusDelete: 'Delete',
      statusInProgress: 'In progress',
      isLoading: false,
      hotTable: null,
      countRow: null,
      undoHistory: [],
      unDeletedPages: []
    }
  },
  computed: {
    ...mapGetters({
      rawData: 'rawData',
      isAuth: 'isAuth',
      duplicateData: 'duplicateData',
      saveData: 'saveData',
      role: 'role',
      username: 'username',
      chunkDataUpdate: 'chunkDataUpdate',
      isAdmin: 'isAdmin',
      editorFilter: 'editorFilter'
    }),
    title() {
      if (this.rawData && this.rawData.detail) {
        return `Raw data [ ${this.rawData.detail.dataDate
          ? moment(this.rawData.detail.dataDate).format('DD/MM/YYYY') + ' - '
          : ''
        }${this.rawData.detail.filename}${this.rawData.detail.criteria && this.rawData.detail.criteria.category
          ? ` - ${this.rawData.detail.criteria.category[0]}`
          : ''
        } ]`
      }
      return ''
    },
    // rawDataResponse () {
    //   return this.rawData
    // },
    chunkId() {
      return this.$route.params._id
    },
    hotRef() {
      return this.$refs.hotTableComponent
    },
    isNone() {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusNone
      }
      return false
    },
    isProgress() {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusInProgress
      }
      return false
    },
    isReview() {
      if (this.rawData) {
        return [this.statusReview, this.statusInReview].includes(
          this.rawData.detail.status
        )
      }
      return false
    },
    isDone() {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusDone
      }
      return false
    },
    isReject() {
      if (this.rawData) {
        return this.rawData.detail.status === this.statusReject
      }
      return false
    },
    highlightHTML() {
      let textInfo = this.text ? this.text.toLowerCase() : this.text
      if (textInfo) {
        if (
          this.matchKeywordInfo &&
        this.matchKeywordInfo.matchedKeyword.length > 0
        ) {
          let keywords = this.matchKeywordInfo.matchedKeyword
          keywords.sort((a, b) => {
            return b.length - a.length
          })
          for (let keyword of keywords) {
            let kw = new RegExp(keyword, 'g')
            textInfo = textInfo.replace(
              kw,
              `<span class="text-success font-weight-bold">${keyword}</span>`
            )
          }
        }

        if (
          this.matchKeywordInfo &&
        this.matchKeywordInfo.matchedExcludedKeyword.length > 0
        ) {
          for (let keyword of this.matchKeywordInfo.matchedExcludedKeyword) {
            let kw = new RegExp(keyword, 'g')
            textInfo = textInfo.replace(
              kw,
              `<span class="text-danger font-weight-bold">${keyword}</span>`
            )
          }
        }
      }

      return textInfo
    },
    isReviewer() {
      return this.username === this.rawData.detail.reviewer
    }
  },
  async mounted() {
    this.tagging()
    window.addEventListener(
      'keydown',
      async (e) => {
        e = e || window.event
        let key = e.keyCode
        let altKey = e.altKey ? e.altKey : key === 18
        let ctrl = e.ctrlKey ? e.ctrlKey : key === 17
        if (key === 82 && altKey) {
          console.log('Alt + R Pressed : Read !')
          await this.individualRead()
        } else if (key === 79 && altKey) {
          console.log('Alt + O Pressed : Delete !')
          this.deleteRow()
        } else if (key === 86 && altKey) {
          console.log('Alt + v Pressed : Duplicate !')
          this.duplicate()
        } else if (key === 90 && ctrl) {
          this.undo()
          console.log('Ctrl + Z Pressed !')
        }
        return false
      },
      false
    )

    if (!this.isAuth) {
      this.$router.replace({ path: '/login' })
    } else {
      await this.getTableConfigInit()
      await this.getRawData(this.$route.params._id)
      if (this.rawData.detail.status === 'Done' && !this.isAdmin) {
        this.$router.replace({ path: '/' })
        return
      }

      if (this.username === this.rawData.detail.assignTo || this.isAdmin) {
        this.setInReview()

        this.isLoadingData = true
        setTimeout(() => {
          this.init()
        }, 0)
        this.isLoadingData = false
      } else {
        this.$router.replace({ path: '/' })
      }
    }
    this.undoHistory = this.$store.getters.undoHistory(this.chunkId)
  },
  beforeDestroy() {
    if (this.$swal && typeof this.$swal.close === 'function') {
      this.$swal.close()
    }
  },
  watch: {
    searchString() {
      let search = this.hot.getPlugin('search')
      search.query(this.searchString)
      this.hot.render()
    }
  },
  methods: {
    ...mapActions({
      getRawData: 'getRawData',
      saveRecords: 'saveRecords',
      updateRecords: 'updateRecords',
      duplicateRecord: 'duplicateRecord',
      updateChunkData: 'updateChunkData',
      deleteRecord: 'deleteRecord',
      setUndoHistory: 'setUndoHistory',
      getAccountConfig: 'getAccountConfig',
      setEditorFilter: 'setEditorFilter'
    }),
    async reloadData() {
      await this.getRawData(this.$route.params._id)
      this.init()
    },
    async setInReview() {
      if (
        this.username === this.rawData.detail.reviewer &&
        this.rawData.detail.status === 'To review'
      ) {
        await this.updateChunkData({
          chunkId: this.chunkId,
          status: 'In review'
        })
      }
    },
    async getTableConfigInit() {
      let account = await this.getAccountConfig()
      this.columnKeyValues = _.keyBy(account.showColumns, 'col_key')
    },
    removeConditions() {
      let selectedCol = this.hot.getSelectedLast()[1]
      const filtersPlugin = this.hot.getPlugin('filters')
      filtersPlugin.removeConditions(selectedCol)
      filtersPlugin.filter()
      if (selectedCol === 1) {
        this.initDefaultFilter()
      }
    },
    async deleteRow() {
      await this.getUndeletedPages()
      let todos = []
      let selectedRows = this.hot.getSelected()
      selectedRows = this.getSelectedRows(selectedRows)
      let cannotDeleteIncident = false
      let undeletedUsername = null
      for (let selectedRow of selectedRows) {
        let rowData = this.hot.getDataAtRow(selectedRow)
        let rowDataObj = this.mapDataArrayToObject(rowData)

        if (rowDataObj.is_incident) {
          console.log('cannot delete record from incident')
          cannotDeleteIncident = true
        } else if (
          this.unDeletedPages.includes(rowDataObj.user_name.toLowerCase())
        ) {
          console.log('cannot delete record from undeleted username')
          undeletedUsername = rowDataObj.user_name
        } else {
          console.time('delete')
          this.hot.setDataAtCell(selectedRow, 1, 'Delete')
          todos.push(this.mapDataArrayToObject(rowData))
          console.timeEnd('delete')
        }
      }

      if (cannotDeleteIncident) {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'warning',
          title: 'Cannot delete record from Incident'
        })
      }

      if (undeletedUsername) {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'warning',
          title: 'Cannot delete record of username ' + undeletedUsername
        })
      }

      this.undoHistory.push(todos)
      this.filter()
    },
    async updateStatus(value) {
      if (value === this.statusReview || value === this.statusInReview) {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'info',
          title: 'Validating...',
          timer: 0,
          showConfirmButton: false
        })
        this.initDefaultFilter()
        await this.reloadData()
        let datas = this.hotSettings.data.slice(0)
        let valid = this.highlightAndValidate(true)
        if (valid) {
          let dataDone = datas.filter(
            (v) =>
              v.record_status === this.statusRead ||
              v.record_status === this.statusDelete
          )
          if (dataDone.length === datas.length) {
            let res = await this.updateChunkData({
              chunkId: this.chunkId,
              status: value
            })
            if (res.error) {
              if (res.error.status_code === '40001') {
                this.$swal({
                  toast: true,
                  position: 'top-end',
                  icon: 'error',
                  title:
                    'Your work has not been completed, please "Reload" your page.',
                  confirmButtonText: 'Reload',
                  showConfirmButton: true,
                  showCloseButton: true
                }).then((result) => {
                  if (result.value) {
                    location.reload()
                  }
                })
              } else {
                this.$swal({
                  toast: true,
                  position: 'top-end',
                  icon: 'error',
                  title: 'Something went wrong',
                  confirmButtonText: 'Reload',
                  showConfirmButton: true,
                  showCloseButton: true
                }).then((result) => {
                  if (result.value) {
                    location.reload()
                  }
                })
              }
            } else {
              this.$swal({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: 'Your work has been submited',
                showConfirmButton: false,
                showCloseButton: true
              })
            }
          } else {
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'error',
              title: 'Some record still not read',
              showConfirmButton: false,
              showCloseButton: true
            })
          }
        } else {
          this.$swal({
            toast: true,
            position: 'top-end',
            icon: 'error',
            title: 'Your work has not been finished',
            showConfirmButton: false,
            showCloseButton: true
          })
        }
      } else {
        if (value === this.statusDone) {
          let isValid = this.highlightAndValidate(true)
          if (isValid) {
            await this.setReviewDone()

            let res = await this.updateChunkData({
              chunkId: this.chunkId,
              status: value
            })
            if (res.error) {
              this.$swal({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'Your work has not been finished',
                showConfirmButton: false,
                showCloseButton: true
              })
            }
          }
        } else {
          let res = await this.updateChunkData({
            chunkId: this.chunkId,
            status: value
          })
          if (res.error) {
            this.$swal({
              toast: true,
              position: 'top-end',
              icon: 'error',
              title: 'Your work has not been finished',
              showConfirmButton: false,
              showCloseButton: true
            })
          }
        }
      }
    },
    highlightAndValidate(isFocusInvalidRow = false) {
      if (!this.hot) return

      let invalidRow = -1
      // console.time('highlight')
      let dataObj = this.hot.getData().map((v) => this.mapDataArrayToObject(v))
      let brandIndex = this.hotSettings.columns
        .map((col) => col.data)
        .indexOf('Brand')
      let channelIndex = this.hotSettings.columns
        .map((col) => col.data)
        .indexOf('Channel')
      let productIndex = this.hotSettings.columns
        .map((col) => col.data)
        .indexOf('Product/Other')
      let subIndex = this.hotSettings.columns
        .map((col) => col.data)
        .indexOf('Sub Attribute')
      let intentionIndex = this.hotSettings.columns
        .map((col) => col.data)
        .indexOf('Intention')

      let usernameIndex = this.hotSettings.columns
        .map((col) => col.data)
        .indexOf('user_name')

      let flagIndex = this.hotSettings.columns
        .map((col) => col.data)
        .indexOf('Flag')

      let isValid = true
      for (let [row, rec] of dataObj.entries()) {
        this.hot.getCellMeta(row, brandIndex).valid = true
        this.hot.getCellMeta(row, channelIndex).valid = true
        this.hot.getCellMeta(row, productIndex).valid = true
        this.hot.getCellMeta(row, subIndex).valid = true
        this.hot.getCellMeta(row, intentionIndex).valid = true
        this.hot.getCellMeta(row, usernameIndex).valid = true
        this.hot.getCellMeta(row, flagIndex).valid = true
        if (rec.is_duplicated_by_user) {
          for (let i = 0; i < Object.keys(rec).length - 1; i++) {
            this.hot.setCellMeta(row, i, 'className', 'duplicated')
          }
        }

        if (
          rec.user_name === 'Anonymous' &&
          ['information/news', 'compliment/news', 'complaint/news'].includes(
            rec['Intention']
          )
        ) {
          this.hot.getCellMeta(row, intentionIndex).valid = false
          this.hot.getCellMeta(row, usernameIndex).valid = false
          isValid = false
        } else {
          this.hot.getCellMeta(row, usernameIndex).valid = true
        }

        if (
          (rec['Channel'] === 'call center-non voice' ||
            rec.Channel === 'call center-voice') &&
          [
            'apply',
            'apply-quality',
            'apply-simplicity',
            'apply-sla',
            'apply-system error',
            'channel availability',
            'service availability',
            'error',
            'system lag',
            'notification',
            'service time',
            'advertising',
            'advisory/research',
            'ceo/executive',
            'staff',
            'business governance',
            'regulators',
            'ease of use (ux)',
            'performance',
            'policy',
            'privilege',
            'promotion/campaign',
            'variety',
            'ui'
          ].includes(rec['Sub Attribute'])
        ) {
          // 2/3 "channel = call center non - voice
          // -> sub attribute /= apply, apply-quality, apply-simplicity, apply-sla, apply-system error,channel availability, service availability, error, system lag, notification, service time, advertising, advisory/research, ceo/exexutive, staff, business governance, regulators, ease of use (ux), performance, policy, privilege, promotion/campaign, variety, ui
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (rec.Channel === 'mobile banking') {
          // 4 "channel = Mobile banking
          // -> sub attribute /= force sale, communication skill/knowledge, process accuracy, ethic, manner, staff appearance,take ownership, convenience/accessibility, facility, waiting time/queue, service time, advisory"
          if (
            [
              'force sale',
              'communication skill/knowledge',
              'process accuracy',
              'ethic',
              'manner',
              'staff',
              'staff appearance',
              'take ownership',
              'convenience/accessibility',
              'facility',
              'waiting time/queue',
              'service time',
              'advisory/research',
              'none'
            ].includes(rec['Sub Attribute'])
          ) {
            this.hot.getCellMeta(row, subIndex).valid = false
            isValid = false
          }
        }

        if (
          rec['Channel'] === 'mobile banking' &&
          ['digital product'].includes(rec['Product/Other']) &&
          ['none'].includes(rec['Sub Attribute'])
        ) {
          // 5/13 "channel = mobile banking, product = digital product
          // -> sub attribute ห้ามเป็น none"
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (
          ['complaint', 'complaint/news'].includes(rec['Intention']) &&
          ['none'].includes(rec['Sub Attribute'])
        ) {
          // 6 "intention =  complaint, complaint/news
          // -> sub attribute /= none"
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (
          rec['Product/Other'] &&
          [
            'bangchak',
            'chula care',
            'cunex',
            'finvest',
            'kapture one',
            'max me',
            'or-xplore',
            'point x',
            'rama app',
            'siriraj connect',
            'tu app',
            'uchoose point',
            'we mahidol'
          ].includes(rec['Product/Other']) &&
          ![
            'mobile banking',
            'call center-non voice',
            'call center-voice'
          ].includes(rec['Channel'])
        ) {
          //  7
          this.hot.getCellMeta(row, channelIndex).valid = false
          isValid = false
        }

        if (
          rec['Product/Other'] &&
          [
            'digital asset',
            'digital product',
            'money transfer',
            'global transfer',
            'prompt pay'
          ].includes(rec['Product/Other']) &&
          ![
            'mobile banking',
            'call center-non voice',
            'call center-voice',
            'branch',
            'branch-banking agent',
            'branch-high network',
            'branch-sme',
            'atm',
            'cdm',
            'pum',
            'electronic machine(others)',
            'internet banking'
          ].includes(rec['Channel'])
        ) {
          //  8
          this.hot.getCellMeta(row, channelIndex).valid = false
          isValid = false
        }

        if (
          ['staff appearance'].includes(rec['Sub Attribute']) &&
          !['branch', 'rm', 'dsa'].includes(
            rec['Channel']
          )
        ) {
          // 9 "sub attribute = staff Appearance
          // -> channel = Branch,RM,DSA"
          this.hot.getCellMeta(row, channelIndex).valid = false
          isValid = false
        }

        if (rec['user_name']) {
          //         35 "username = changeinto21, pineapplesnews, infoquestnews, kapookdotcom, siamrath_online, thailandplus1, moneynbanking, bts_skytrain, shobproth, prachachat, yindii_app, moneynbankingch, techsauceth, tonnuhm123, sale here, เก็บเบี้ยใต้ถุนร้าน, pro masscomm limited, aec10news, kaohoon, intrend news, zoombusinessnews, บลูชิพ, efm station, columnai, zoombusinessnews, nnthotnews, phetsiam, สารพันข่าว, thunhoon1, msn, bangkokstock, onetrader168, ryt9, acnewsmagonline, realmsknews, wealthtuktoon,springnews
          // -> intention = information/news, compliment/news, complaint/news
          // "
          for (let userName of [
            'changeinto21',
            'pineapplesnews',
            'infoquestnews',
            'kapookdotcom',
            'siamrath_online',
            'thailandplus1',
            'moneynbanking',
            'bts_skytrain',
            'shobproth',
            'prachachat',
            'yindii_app',
            'moneynbankingch',
            'techsauceth',
            'tonnuhm123',
            'sale here',
            'เก็บเบี้ยใต้ถุนร้าน',
            'pro masscomm limited',
            'aec10news',
            'kaohoon',
            'intrend news',
            'zoombusinessnews',
            'บลูชิพ',
            'efm station',
            'columnai',
            'zoombusinessnews',
            'nnthotnews',
            'phetsiam',
            'สารพันข่าว',
            'thunhoon1',
            'msn',
            'bangkokstock',
            'onetrader168',
            'ryt9',
            'acnewsmagonline',
            'realmsknews',
            'wealthtuktoon',
            'springnews',
            'anonymous'
          ]) {
            if (
              rec['user_name'] === userName &&
              ![
                'information/news',
                'compliment/news',
                'complaint/news'
              ].includes(rec['Intention'])
            ) {
              this.hot.getCellMeta(row, intentionIndex).valid = false
              isValid = false
            }
          }
        }

        if (
          rec['Channel'] &&
          rec['Channel'] === 'mobile banking' &&
          rec['Product/Other'] === 'mobile banking'
        ) {
          this.hot.getCellMeta(row, productIndex).valid = false
          isValid = false
        }

        if (rec['user_name']) {
          // 34 "username = thanachartinsurance - tni ,scbam,เคทีซี,make by kbank,kss - krungsri securities,krungsri capital,cardxthailand,innovestxsecurities,InnovestX,bangkokbanksme,ktcrealprivilege,bualuangsec, scbsecurities.thailand,krungsri.first.choice,ktcworldcommunity,robinhooddeliveryapp,krungsrisimple,K8888,KSecurities,kbanklive,K SME,KBank_Live,KBank Live,Bualuang 1333, Bangkok Bank,Bangkok Bank SME,Kept by krungsri,KrungsriCard,Krungsri Simple,Central The 1 Credit Card,Krungsri First Choice,Thanachart Bank,ttbbankofficial,ttb bank,KTB8989, KtcPrivilege,Ktc Real Privileges,Krungthai-AXA,Krungthai_Care,Krungthai Care,FINNIX - ฟินนิกซ์,scb_thailand,SCB Securities,SCB Thailand,krungthaibank
          // -> intention = information/news
          // "
          let usernameLowerCase = rec['user_name'].toLowerCase()
          for (let keyword of [
            'thanachartinsurance - tni',
            'scbam',
            'เคทีซี',
            'make by kbank',
            'kss - krungsri securities',
            'krungsri capital',
            'cardxthailand',
            'innovestxsecurities',
            'innovestx',
            'bangkokbanksme',
            'ktcrealprivilege',
            'bualuangsec',
            'scbsecurities.thailand',
            'krungsri.first.choice',
            'ktcworldcommunity',
            'robinhooddeliveryapp',
            'krungsrisimple',
            'k8888',
            'ksecurities',
            'kbanklive',
            'k sme',
            'kbank_live',
            'kbank live',
            'bualuang 1333',

            'bangkok bank',
            'bangkok bank sme',
            'kept by krungsri',
            'krungsricard',
            'krungsri simple',
            'central the 1 credit card',
            'krungsri first choice',
            'thanachart bank',
            'ttbbankofficial',
            'ttb bank',
            'ktb8989',
            'ktcprivilege',
            'ktc real privileges',
            'krungthai-axa',
            'krungthai_care',
            'krungthai care',
            'finnix - ฟินนิกซ์',
            'scb_thailand',
            'scb securities',
            'scb thailand',
            'krungthaibank'
          ]) {
            if (
              usernameLowerCase === keyword &&
              ![
                'information/news',
                'compliment/news',
                'complaint/news',
                'participation'
              ].includes(rec['Intention'])
            ) {
              this.hot.getCellMeta(row, intentionIndex).valid = false
              isValid = false
              break
            }
          }
        }

        if (
          rec['Product/Other'] &&
          ['digital asset'].includes(rec['Product/Other']) &&
          ['mobile banking'].includes(rec['Channel']) &&
          ['none'].includes(rec['Sub Attribute'])
        ) {
          //  38
          this.hot.getCellMeta(row, subIndex).valid = true
          isValid = true
        }

        if (
          rec['Product/Other'] &&
          ['money transfer'].includes(rec['Product/Other']) &&
          ['mobile banking'].includes(rec['Channel']) &&
          ['service availability'].includes(rec['Sub Attribute']) &&
          !['product'].includes(rec['Flag'])
        ) {
          //  105
          this.hot.getCellMeta(row, flagIndex).valid = false
          isValid = false
        }

        if (
          ['channel'].includes(rec['Flag']) &&
          ['none', 'mobile banking', 'internet banking'].includes(rec['Channel'])
        ) {
          //  106
          this.hot.getCellMeta(row, channelIndex).valid = false
          isValid = false
        }

        if (rec.Brand && rec.Brand.includes(',')) {
          this.hot.getCellMeta(row, brandIndex).valid = false
          isValid = false
        }
        if (rec.Channel && rec.Channel.includes(',')) {
          this.hot.getCellMeta(row, channelIndex).valid = false
          isValid = false
        }
        if (rec['Product/Other'] && rec['Product/Other'].includes(',')) {
          this.hot.getCellMeta(row, productIndex).valid = false
          isValid = false
        }
        if (rec['Sub Attribute'] && rec['Sub Attribute'].includes(',')) {
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }
        if (rec.Intention && rec.Intention.includes(',')) {
          this.hot.getCellMeta(row, intentionIndex).valid = false
          isValid = false
        }

        if (
          this.columnKeyValues['Channel'].data &&
          !this.columnKeyValues['Channel'].data.includes(rec['Channel'])
        ) {
          this.hot.getCellMeta(row, channelIndex).valid = false
          isValid = false
        }

        if (
          this.columnKeyValues['Product/Other'].data &&
          !this.columnKeyValues['Product/Other'].data.includes(
            rec['Product/Other']
          )
        ) {
          this.hot.getCellMeta(row, productIndex).valid = false
          isValid = false
        }

        if (
          this.columnKeyValues['Sub Attribute'].data &&
          !this.columnKeyValues['Sub Attribute'].data.includes(
            rec['Sub Attribute']
          )
        ) {
          this.hot.getCellMeta(row, subIndex).valid = false
          isValid = false
        }

        if (
          this.columnKeyValues['Intention'].data &&
          !this.columnKeyValues['Intention'].data.includes(rec['Intention'])
        ) {
          this.hot.getCellMeta(row, intentionIndex).valid = false
          isValid = false
        }

        // if (rec['Sensitive Area'].includes(',')) {
        //   this.hot.getCellMeta(row, sensitiveAreaIndex).valid = false
        //   isValid = false
        // }
        if (!isValid && invalidRow < 0) {
          invalidRow = row
        }
      }
      if (isFocusInvalidRow) {
        this.hot.selectRows(invalidRow)
      }
      this.hot.render()
      return isValid
    },
    getSelectedRows(allSelected) {
      let rows = []
      if (allSelected) {
        for (let selected of allSelected) {
          let range = [selected[0], selected[2]]
          range.sort()
          let rowStart = range[0]
          let rowEnd = range[1]
          if (rowStart === rowEnd) {
            rows.push(rowStart)
          } else {
            for (let i = rowStart; i <= rowEnd; i++) {
              rows.push(i)
            }
          }
        }
        rows.sort()
      }
      rows = new Set(rows)
      return rows
    },
    async individualRead() {
      let selectedRows = this.hot.getSelected()
      selectedRows = this.getSelectedRows(selectedRows)
      for (let selectedRow of selectedRows) {
        this.hot.setDataAtCell(selectedRow, 1, 'Read')
      }
    },
    async readData() {
      console.time('read')
      let data = this.hot.getData()
      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: 'Validating...',
        showConfirmButton: false,
        timer: 0
      })
      let valid = this.highlightAndValidate(true)
      if (valid) {
        let result = []
        data.map((rec, index) => {
          this.hotSettings.data.find((data, inx) => {
            if (rec[0] === data._id) {
              result.push(data)
            }
          })
        })

        await this.saveRecords({ chunkId: this.chunkId, records: result })
        let responseData = this.saveData
        let datas = this.hotSettings.data.slice(0)
        responseData.map((rec) => {
          let row = null
          datas.find((data, index) => {
            if (rec._id === data._id) {
              row = index
            }
          })
          datas.splice(row, 1, rec)
        })
        this.hot.loadData(datas)
        this.hotSettings.data = datas
        const filtersPlugin = this.hot.getPlugin('filters')
        filtersPlugin.filter()
        console.timeEnd('read')
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'success',
          title: 'Read all',
          showConfirmButton: false,
          showCloseButton: true
        })
      } else {
        this.$swal({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: 'Your work has not been finished',
          showConfirmButton: false,
          showCloseButton: true
        })
      }
    },
    changeData(index, column, oldValue, newValue) {
      // if (this.$swal && typeof this.$swal.close === 'function') {
      //   this.$swal.close()
      // }

      let data = this.hot.getData()
      let idOfData = null
      data.find((rec, idx) => {
        if (index === idx) {
          idOfData = rec[0]
        }
      })

      if (!this.isInProgress && !this.isReview) {
        this.updateChunkData({
          chunkId: this.chunkId,
          status: this.statusInProgress
        })
        this.isInProgress = true
      }

      if (this.isReview && this.isReviewer) {
        const fieldChanges = ['Brand', 'Sub Brand', 'Flag', 'Channel', 'Product/Other', 'Sub Attribute', 'Intention']
        if (fieldChanges.includes(column)) {
          for (let record of this.hotSettings.data) {
            if (record._id === idOfData) {
              record.review_status = 'Wrong'
              break
            }
          }
        }
      }

      if (!this.isDuplicating) {
        for (let record of this.hotSettings.data) {
          if (idOfData === record._id) {
            this.updateRecords({ chunkId: this.chunkId, records: [record] })
            break
          }
        }
      }
    },
    async duplicate(key, selection, clickEvent, selectedRow) {
      console.time('duplicate')
      this.isDuplicating = true
      if (typeof selectedRow !== 'number') {
        selectedRow = this.hot.getSelectedLast()[0]
      }

      let rowData = this.hot.getDataAtRow(selectedRow)
      let id = rowData[0]

      await this.duplicateRecord({ chunkId: this.chunkId, _id: id })
      console.log('duplicate done')
      await this.updateRecords({
        chunkId: this.chunkId,
        records: [{ _id: id, is_duplicated_by_user: true }]
      })
      console.log('update duplicate done')

      let nextRow = null
      this.hotSettings.data = this.hotSettings.data.map((rec, index) => {
        if (rec._id === id) {
          rec.is_duplicated_by_user = true
          nextRow = index + 1
          rec = Object.assign({}, rec)
        }
        return rec
      })

      let data = this.hotSettings.data.slice(0)
      let responseData = this.duplicateData
      data.splice(nextRow, 0, responseData)
      this.hotSettings.data = data
      this.hot.loadData(data)

      this.filter()
      this.isDuplicating = false
      console.timeEnd('duplicate')
    },
    async showDuplicateMultipleForm() {
      this.duplicateRecordInput = 0
      this.selectedRow = this.hot.getSelectedLast()[0]
      this.$refs['show_duplicate_modal'].show()
    },
    async duplicateMultiple() {
      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'info',
        title: 'Duplicating...',
        timer: 0,
        showConfirmButton: false
      })
      for (let index = 0; index < this.duplicateRecordInput; index++) {
        await this.duplicate(null, null, null, this.selectedRow)
        await this.delay(200)
      }
      this.selectedRow = null
      this.$swal({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: 'Duplicated',
        timer: 3000,
        showConfirmButton: false
      })
    },
    init() {
      const rawData = this.rawData
      const header = rawData.format.showColumns
      let dataRecords = rawData.records.slice(0)
      let headerData = []
      let columnData = []
      let colWidth = []
      let hiddenColumns = []
      let index = 0
      for (let key of header) {
        if (key.visible) {
          headerData.push(key.col_header)
          colWidth.push(key.width ? key.width : 120)
          columnData.push({
            data: key.col_key,
            type: key.col_type,
            source: key.data ? key.data : null,
            strict: key.strict === undefined ? true : key.strict,
            allowInvalid: key.strict === undefined ? true : key.strict,
            wordWrap: false,
            readOnly: key.disable ? key.disable : null,
            allowEmpty: false
          })
          if (key.hidden) {
            hiddenColumns.push(index)
          }
          index++
        }
      }
      this.hotSettings.colWidths = colWidth
      this.hotSettings.colHeaders = headerData
      this.hotSettings.columns = columnData
      this.hotSettings.hiddenColumns = {
        copyPasteEnabled: true,
        indicators: true,
        columns: hiddenColumns
      }
      this.hotSettings.beforeKeyDown = function (event) {
        if (event.key === 'Tab') {
          const selectedValue = document.querySelector('.handsontableInput').value
          if (selectedValue) {
            const column = this.getSelected()[0][1]
            const row = this.getSelected()[0][0]
            const matchData = []
            const el = document.querySelector(`.listbox.handsontable`)
            if (el && el.style.display !== 'none') {
              document.querySelectorAll('.listbox.handsontable tr').forEach(el => {
                matchData.push(el.textContent)
              })

              if (matchData.length > 0) {
                // If the selected value exists in the list, select the first match
                const firstMatch = matchData[0]
                setTimeout(() => {
                  this.setDataAtCell(row, column, firstMatch)
                }, 100)
              }
            }
          }
        }
      }

      this.hotSettings.data = JSON.parse(JSON.stringify(dataRecords))
      this.hot = new Handsontable(this.$refs.table, this.hotSettings)
      this.initDefaultFilter()
      this.countRow = this.hot.getData() ? this.hot.getData().length : 0
    },
    mapDataArrayToObject(dataCol) {
      const header = this.hotSettings.columns
      let data = {}
      for (let [idx, key] of header.entries()) {
        data[key.data] = dataCol[idx]
      }
      return data
    },
    mapObjectToDataArray(dataObj) {
      const header = this.hotSettings.columns
      let data = []
      for (let key of header) {
        data.push(dataObj[key.data])
      }
      return data
    },
    validateData(isSelectRow = false) {
      console.time('validate')
      this.invalidCell = []
      let that = this
      return new Promise((resolve, reject) => {
        let data = this.hot.getData().slice(0)

        this.hot.validateRows(
          data.map((v, i) => i),
          (valid) => {
            console.timeLog('validate')
            let isValid = valid

            let rows = data.map((d) => that.mapDataArrayToObject(d))

            let channelIndex = that.hotSettings.columns
              .map((col) => col.data)
              .indexOf('Channel')
            let productIndex = that.hotSettings.columns
              .map((col) => col.data)
              .indexOf('Product/Other')

            for (let [idx, row] of rows.entries()) {
              if (
                row.Channel === 'mobile banking' &&
                row['Product/Other'] === 'mobile banking'
              ) {
                that.hot.getCellMeta(idx, channelIndex).valid = false
                that.hot.getCellMeta(idx, productIndex).valid = false
                isValid = false
              }
            }
            that.hot.render()
            if (isSelectRow) {
              let invalidRow = this.invalidCell[this.invalidCell.length - 1]
              if (invalidRow >= 0) {
                that.hot.selectRows(invalidRow)
              }
            }
            console.timeEnd('validate')
            resolve(isValid)
          }
        )
      })
    },
    initDefaultFilter() {
      const filtersPlugin = this.hot.getPlugin('filters')
      filtersPlugin.clearConditions()

      if (this.editorFilter && this.editorFilter.length > 0) {
        for (const condition of this.editorFilter) {
          filtersPlugin.addCondition(condition.column, condition.name, condition.args)
        }
      } else {
        filtersPlugin.addCondition(1, 'by_value', [['New', 'Read']])
      }
      filtersPlugin.filter()
    },
    undo() {
      let todos = this.undoHistory.pop()
      if (todos) {
        for (let record of todos) {
          this.hotSettings.data = this.hotSettings.data.map((v) => {
            if (v._id === record._id) {
              v = Object.assign({}, record)
              this.updateRecords({ chunkId: this.chunkId, records: [record] })
            }
            return v
          })
        }
        this.hot.loadData(this.hotSettings.data)
        const filtersPlugin = this.hot.getPlugin('filters')
        filtersPlugin.filter()
      }
    },
    filter() {
      setImmediate(() => {
        const filtersPlugin = this.hot.getPlugin('filters')
        filtersPlugin.filter()
      })
    },
    tagging() {
      this.$socket.emit('tagging', { chunkId: this.chunkId })
    },
    async getUndeletedPages() {
      return serviceRoutes
        .getUndeletedPages()
        .then((res) => {
          let pages = res.data.data || []
          this.unDeletedPages = pages.map((v) => v.page_name.toLowerCase())
        })
        .catch(() => {
          console.log('Cannot get undeleted page')
        })
    },
    checkKeyword() {
      if (!this.text) return

      this.isCheckKeyword = true
      this.matchKeywordInfo = null
      let data = {
        account: 'kbank',
        msg: this.text
      }
      serviceRoutes
        .keywordChecker(data)
        .then((res) => {
          if (res.data.data) {
            const isMatch = res.data.data.is_match
            const matchedKeyword = res.data.data.matched_keyword || []
            const matchedExcludedKeyword =
              res.data.data.matched_excluded_keyword || []
            const categoryLevels = res.data.data.levels || []

            const levelLabel = [
              'Brand',
              'Channel',
              'Product',
              'Sub Attribute',
              'Intention'
            ]

            let levelFilter = categoryLevels.filter(v => v)
              .map((levelInfos, index) => {
                let cats = levelInfos.filter(
                  (category) => category.matchingWords.length > 0
                )
                return {
                  level: index,
                  label: levelLabel[index],
                  categories: cats
                }
              })
              .filter((v) => v.categories.length)

            this.matchKeywordInfo = {
              isMatch,
              matchedKeyword,
              matchedExcludedKeyword,
              levels: levelFilter
            }
            console.log(this.matchKeywordInfo)
          }
          this.isCheckKeyword = false
        })
        .catch((err) => {
          console.error(err)
          this.isCheckKeyword = false
        })
    },
    delay(ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve()
        }, ms)
      })
    },
    changeFilter() {
      const filters = this.hot.getPlugin('filters')
      const conditionData = []
      if (filters && filters.conditionCollection && filters.conditionCollection.conditions && filters.conditionCollection.conditions.conjunction) {
        const conditions = filters.conditionCollection.conditions.conjunction
        for (const column in conditions) {
          const condition = conditions[column][0] // array
          if (condition) {
            conditionData.push({ column: Number(column), name: condition.name, args: condition.args })
          }
        }
      }
      this.setEditorFilter(conditionData)
    },
    async setReviewDone() {
      let dataObj = this.hot.getData().map((v) => this.mapDataArrayToObject(v))
      const correctDatas = dataObj.filter(v => v.review_status !== 'Wrong').map(v => ({ _id: v._id, review_status: 'Correct' }))
      await this.updateRecords({ chunkId: this.chunkId, records: correctDatas })
      const dataUpdateReviewStatus = dataObj.map(v => {
        return { ...v, review_status: v.review_status === 'Wrong' ? 'Wrong' : 'Correct' }
      })
      this.hot.loadData(dataUpdateReviewStatus)
    }
  }
}
</script>
<style scoped>
.text-info-area {
  word-break: break-all;
  resize: both;
  overflow: auto;
  border: solid 1px;
  padding: 10px;
  height: 90px;
  max-width: 100%;
  background-color: #fff;
  color: #000;
}
</style>

<style>
.ht_editor_visible textarea {
  width: auto !important;
}
</style>
